<!-- <app-layout></app-layout> -->
<ng-container #modal></ng-container>
<div [@routeAnimationTrigger]="prepareRoute(outlet)" style="display: contents;">
    <router-outlet #outlet="outlet"></router-outlet>
</div>

